import Sortable from 'sortablejs'
import TableFilter from 'tablefilter'
import {ArgumentError} from './error.js'
import Is from './is.js'

export default class Table
{
	static init()
	{
		this._sorter()
		this._filter()
		this._order()
		this._cell_link()
		this._sortable()
	}

	static _sorter()
	{
		const list = $('table.__sorter')
		if(list.length === 0) return

		list.each((index, element) =>
		{
			const table = $(element)

			const column = Is.int(table.data('sort-column')) ? Number(table.data('sort-column')) : 0
			const order = table.data('sort-order') === 0 ? 0 : 1

			// noinspection JSUnusedGlobalSymbols
			table.tablesorter({
				sortList        : [[column, order]],
				sortInitialOrder: 'desc',

				textExtraction: (node) =>
				{
					const value = $(node).attr('data-sort')
					return typeof value !== 'undefined' ? value : $(node).text()
				},
			})
		})
	}

	static _filter()
	{
		$('table.__table-filter').each((index, element) =>
		{
			const table_filter = new TableFilter(element, {
				auto_filter  : {
					delay: 100,
				},
				single_filter: true,
			})

			// noinspection JSUnresolvedFunction
			table_filter.init()

			element.querySelector('input').placeholder = '絞り込み'
		})
	}

	static _order()
	{
		const table_order = $('table.__sorter_remote')
		if(table_order.length === 0) return

		const key = table_order.data('order-key') || 'order'
		const key_reverse = table_order.data('order-key-reverse') || 'reverse'
		const key_page = table_order.data('order-key-page') || 'page'

		const match = new RegExp(`\\b${key}=([\\w.]+)`).exec(location.search)

		let ordered = match !== null ? match[1] : undefined
		const reversed = !location.search.match(new RegExp(`\\b${key_reverse}=0`))

		// noinspection JSCheckFunctionSignatures
		table_order.find('thead th').each((index, element) =>
		{
			const cell = $(element)

			const name = cell.data('order')
			if(!name) return

			if(ordered === undefined) ordered = name

			cell.addClass('tablesorter-header')
			if(name === ordered) cell.addClass(reversed ? 'tablesorter-headerDesc' : 'tablesorter-headerAsc')

			cell.on('click', () =>
			{
				if(!Is.filled(name)) throw new ArgumentError('No name given to sort')
				const reverse = !cell.hasClass('tablesorter-headerDesc')

				cell.parent().find('th').each((index, element) =>
				{
					const cell = $(element)

					cell.removeClass('tablesorter-headerAsc')
					cell.removeClass('tablesorter-headerDesc')
				})

				if(reverse)
				{
					cell.removeClass('tablesorter-headerAsc')
					cell.addClass('tablesorter-headerDesc')
				}
				else
				{
					cell.removeClass('tablesorter-headerDesc')
					cell.addClass('tablesorter-headerAsc')
				}

				const query = location.search.replace(new RegExp(`[&?]${key}=[\\w.]*`), '').replace(new RegExp(`[&?]${key_reverse}=[01]`), '').replace(new RegExp(`[&?]${key_page}=\\d*`), '')

				const connector = query === '' ? '?' : '&'
				location.search = `${query}${connector}${key}=${name}&${key_reverse}=${reverse ? 1 : 0}`
			})
		})
	}

	static _cell_link()
	{
		$('table.__list tbody tr').each((index, row) =>
		{
			const link = $(row).data('href')
			if(!link) return

			const target = $(row).data('href-target')
			const row_element = $(row)

			// noinspection JSCheckFunctionSignatures
			row_element.find('> td:not(.__no_link)').each((index2, cell) =>
			{
				if(cell.firstChild && cell.firstChild.nodeName === 'A')
				{
					$(cell.firstChild).addClass('inline-block')
					return
				}

				const cell_element = $(cell)
				const anchor = document.createElement('a')

				if(target) anchor.target = target
				anchor.href = link

				cell_element.contents().appendTo(anchor)
				$(anchor).appendTo(cell_element)
			})
		})
	}

	static _sortable()
	{
		$('.__sortable').each((index, element) =>
		{
			new Sortable(element, {
				handle     : 'i.fa-grip-vertical',
				animation  : 150,
				ghostClass : 'sortable-ghost',
			})
		})
	}
}
